import { ActionAnswer } from 'src/api/quizzes/types'

enum ActionKey {
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  Space = 'Space',
}

export const allowedCodes = [
  ActionKey.ArrowUp,
  ActionKey.ArrowDown,
  ActionKey.ArrowLeft,
  ActionKey.ArrowRight,
  ActionKey.Space,
]

export const keyCodeToAnswer = (keyCode: string) => {
  switch (keyCode) {
    case ActionKey.ArrowDown:
      return ActionAnswer.down
    case ActionKey.ArrowUp:
      return ActionAnswer.up
    case ActionKey.ArrowLeft:
      return ActionAnswer.left
    case ActionKey.ArrowRight:
      return ActionAnswer.right
    case ActionKey.Space:
      return ActionAnswer.skip
    default:
      // eslint-disable-next-line
      return
  }
}

export const animationVariants = {
  [ActionAnswer.down]: {
    y: 'calc(4/3 * 100vh)',
    rotate: -20,
  },
  [ActionAnswer.up]: {
    y: 'calc(-4/3 * 100vh)',
    rotate: 20,
  },
  [ActionAnswer.left]: {
    // 4/3 of window width because of custom rotate
    x: 'calc(-4/3 * 100vw)',
    rotate: -20,
  },
  [ActionAnswer.right]: {
    x: 'calc(4/3 * 100vw)',
    rotate: 20,
  },
  [ActionAnswer.skip]: { scale: 0 },
}

const MIN_SWIPE_LENGTH = 70

export const determineSwipeEmotion = (offset: { x: number; y: number }) => {
  if (offset.x > MIN_SWIPE_LENGTH && Math.abs(offset.x) > Math.abs(offset.y)) {
    return ActionAnswer.right
  }
  if (offset.x < -MIN_SWIPE_LENGTH && Math.abs(offset.x) > Math.abs(offset.y)) {
    return ActionAnswer.left
  }
  if (offset.y > MIN_SWIPE_LENGTH && Math.abs(offset.y) > Math.abs(offset.x)) {
    return ActionAnswer.down
  }
  if (offset.y < -MIN_SWIPE_LENGTH && Math.abs(offset.y) > Math.abs(offset.x)) {
    return ActionAnswer.up
  }
  // eslint-disable-next-line no-useless-return
  return
}
